import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  initVehicle({ commit }) {
    commit(types.INIT_VEHICLE)
  },
  setVehicle({ commit }, data) {
    commit(types.SET_VEHICLE, data)
  },
  updateVehicle({ commit }, data) {
    commit(types.UPDATE_VEHICLE, data)
  },
  async getVehicles({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getVehicles', () =>
      http.get('vehicle/vehicles', {
        params: searchOptions
      })
    )
    commit(types.SET_VEHICLES, r.data)
    return r.data
  },
  async getVehicle({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getVehicle', () =>
      http.get('vehicle/vehicle', {
        params: { id }
      })
    )
    commit(types.SET_VEHICLE, r.data)
    return r.data
  },
  async getOwnerVehicles({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getOwnerVehicles', () => http.get(`vehicle/ownerVehicles?contact=${id}`))
    commit(types.SET_VEHICLES, r.data)
    return r.data
  },
  async saveVehicle({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveVehicle', () => http.post('vehicle/saveVehicle', data))
    return r.data
  },
  async deleteVehicle({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'deleteVehicle', () => http.post('vehicle/deleteVehicle', data))
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/vehicles/actions.js